import { render, staticRenderFns } from "./GlobalOffersScraperDataTable.vue?vue&type=template&id=0f6a5878&scoped=true&lang=html&"
import script from "./GlobalOffersScraperDataTable.vue?vue&type=script&lang=js&"
export * from "./GlobalOffersScraperDataTable.vue?vue&type=script&lang=js&"
import style0 from "./GlobalOffersScraperDataTable.vue?vue&type=style&index=0&id=0f6a5878&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6a5878",
  null
  
)

export default component.exports